import { createAction } from 'redux-actions'

import { VideoCallUser } from '@tabeeb/modules/../users/types'

import { JitsiRemoteTrack, JitsiLocalTrack } from 'lib-jitsi-meet'

export const updateLocalTrack = createAction<JitsiLocalTrack>('UPDATE_LOCAL_TRACK')
export const removeLocalTrack = createAction<JitsiLocalTrack>('REMOVE_LOCAL_TRACK')
export const setLocalTracks = createAction<JitsiLocalTrack[]>('SET_LOCAL_TRACKS')
export const resetLocalTracks = createAction<void>('RESET_LOCAL_TRACKS')
export const setTracksError = createAction<string>('SET_TRACKS_ERROR')
export const setTrackMuteState = createAction<boolean>('SET_TRACK_MUTE_STATE')
export const addRemoteTrack = createAction<{ userId: number; track: JitsiRemoteTrack }>('ADD_REMOTE_TRACK')
export const removeRemoteTrack = createAction<{ userId: number; track: JitsiRemoteTrack }>('REMOVE_REMOTE_TRACK')
export const resetTracksForUser = createAction<number>('RESET_TRACKS_FOR_USER')
export const setLargeVideoUser = createAction<VideoCallUser | null>('SET_LARGE_VIDEO_USER')
export const setGridUser = createAction<VideoCallUser | null>('SET_GRID_USER')
export const disposeTracks = createAction<void>('DISPOSE_TRACKS')
export const createLocalTracks = createAction<void>('CREATE_LOCAL_TRACKS')
export const attachTrack = createAction<{ userId: number; track: JitsiLocalTrack | JitsiRemoteTrack }>('ATTACH_TRACK')
export const stopTracks = createAction<void>('STOP_TRACKS')
export const trackStopped = createAction<void>('TRACK_STOPPED')
export const toggleLargeVideo = createAction<{ userId: number; isVideo?: boolean }>('TOGGLE_LARGE_VIDEO')
export const attachLargeVideo = createAction<{ userId: number; isLargeVideo?: boolean }>('ATTACH_LARGE_VIDEO')
export const replaceTrack = createAction<{ track: JitsiLocalTrack; approvedByLocalRecording?: boolean }>(
  'REPLACE_TRACK'
)
export const removeLocalVideoTrack = createAction<void>('REMOVE_LOCAL_VIDEO_TRACK')
export const bindTrackEvents = createAction<JitsiLocalTrack | JitsiRemoteTrack>('BIND_TRACK_EVENTS')
export const unbindTrackEvents = createAction<void>('UNBIND_TRACK_EVENTS')
export const onTrackMuteChanged = createAction<JitsiRemoteTrack>('ON_TRACK_MUTE_CHANGED')
export const detachTracksForUser = createAction<number>('DETACH_TRACKS_FOR_USER')
export const initTracksForUser = createAction<number>('INIT_TRACKS_FOR_USER')
export const addPreviewTrack = createAction<JitsiLocalTrack>('ADD_PREVIEW_TRACK')
export const resetPreviewTracks = createAction<void>('RESET_PREVIEW_TRACKS')
export const toggleGridView = createAction<boolean>('TOGGLE_GRID_VIEW')
export const toggleMobilePriorityView = createAction<boolean>('TOGGLE_MOBILE_PRIORITY_VIEW')
export const toggleMobileLargeVideo = createAction<{ userId: number }>('TOGGLE_MOBILE_LARGE_VIDEO')
export const toggleMobileUserList = createAction<boolean>('TOGGLE_MOBILE_USER_LIST')
export const toggleMobileFlash = createAction<boolean>('TOGGLE_MOBILE_FLASH')
export const updateMobileZoom = createAction<{
  userId: number
  contentId: number
  zoomValue: number
}>('UPDATE_MOBILE_ZOOM')
